import { Controller } from 'stimulus';

export default class extends Controller {
  expectedCount(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const originalContent = button.innerHTML;
    button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading';
    button.disabled = true;
    const csvExportId = button.dataset.csvExportId;
    Rails.ajax({
      type: 'GET',
      url: `csv_exports/${csvExportId}/expected_count`,
      dataType: 'json',
      success: (response) => {
        button.innerHTML = `<i class='fa fa-eye'></i> Count: ${response.count}`;
        button.disabled = false;
      },
      error: (response) => {
        button.innerHTML = originalContent;
        button.disabled = false;
        console.log(response);
      }
    });
  }
}